import { AmenitiesPage } from "apps/oneOnboarding/amenities/Page";
import { criticalMark } from "libs/analytics/criticalMark";

export default criticalMark(AmenitiesPage, "AmenitiesPage");
